import { useHistory, useLocation } from "react-router-dom";
import {
  CalcSIPEnddt,
  reinitate,
  stpTransaction,
} from "../../../store/actions";
import { useDispatch } from "react-redux";
import { DetailsGroup } from "../transactions/newPurchaseConfirm";
import { useState, useEffect } from "react";
import { CartItemsMap } from "../../../store/types";
import { CustomizedDialogsforReintitate } from "../customModal";
import { convertDate, handleError } from "../../../utils/cart";
import { getFrequencyName } from "../transactions/tranUtils";

interface LocationState {
  fundCode: string;
  ihno: string;
}

export default function Stp() {
  const { state } = useLocation<LocationState>();

  const history = useHistory();
  const dispatch = useDispatch();

  const { ihno } = state;

  // @ts-ignore
  const [payload, setPayload] = useState<CartItemsMap["STP"]>({});
  const [isOpen, setIsOpen] = useState(false);
  const [referenceNumber, setReferenctNumber] = useState("");

  useEffect(() => {
    (async function () {
      try {
        const response = await reinitate<"STP">(ihno)(dispatch);
        const { scheme, plan, option } = response;
        const {
          DtData: [dates],
        } = await CalcSIPEnddt({
          Fund: response.fund,
          startDate: response.stpDay,
          installments: response.noOfTransfers,
          Frequency: getFrequencyName(response.frequency),
          trtype: "STP",
          sch: `${scheme}-${plan}-${option}`,
        })(dispatch);
        const { SIP_StartDate, SIP_EndDate } = dates;
        setPayload({
          ...response,
          stpStartDate: SIP_StartDate,
          stpEndDate: SIP_EndDate,
        });
      } catch (error) {
        alert(error);
      }
    })();
  }, [dispatch, ihno]);

  function goToDashboard() {
    history.push("/dashboard");
  }

  async function onConfirm() {
    try {
      const response = await stpTransaction({
        ...payload,
        stpStartDate: convertDate(payload.stpStartDate),
        stpEndDate: convertDate(payload.stpEndDate),
      })(dispatch);
      if (response) {
        const { ihno } = response;
        setReferenctNumber(ihno);
        setIsOpen(true);
      }
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <div
      className="table_border"
      style={{
        margin: "32px 48px",
      }}
    >
      <div
        className="container-fluid d-flex flex-column shadow-sm bg-white rounded"
        style={{
          minHeight: "240px",
          padding: "24px 36px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <p className="text-primary mb-0" style={{ fontSize: 14 }}>
            Confirm re-initiation of STP transaction
          </p>
        </div>
        <DetailsGroup
          mainLabel={"Investor Name"}
          subLabel={payload.investorName}
          mainLabel1={"Investor Pan"}
          subLabel2={payload.pan}
        />
        <DetailsGroup
          mainLabel={"Email"}
          subLabel={payload.email}
          mainLabel1={"Mobile"}
          subLabel2={payload.mobile}
        />
        <DetailsGroup
          mainLabel={"SwitchOut Scheme"}
          subLabel={payload.switchOutSchemeName}
          mainLabel1={"switchIn Scheme"}
          subLabel2={payload.switchInSchemeName}
        />
        <DetailsGroup
          mainLabel={"Stp Start Date"}
          subLabel={payload.stpStartDate}
          mainLabel1={"Stp End Date"}
          subLabel2={payload.stpEndDate}
        />
        <DetailsGroup
          mainLabel={"Folio"}
          subLabel={payload.folio}
          mainLabel1={"No of transfers"}
          subLabel2={payload.noOfTransfers}
        />
        <DetailsGroup
          mainLabel={"STP Option"}
          subLabel={payload.stpOption}
          mainLabel1={"Amount"}
          subLabel2={payload.stpOption === "Fixed" ? payload.amount : "-"}
        />

        <DetailsGroup
          mainLabel={"Euin Declaration"}
          subLabel={payload.euinDeclaration === "Y" ? "Yes" : "No"}
          mainLabel1={"Euin Code"}
          subLabel2={payload.euin || "-"}
        />
        <DetailsGroup
          mainLabel={"Arn-Code"}
          subLabel={payload.arn}
          mainLabel1={"Sub Arn-Code"}
          subLabel2={payload.subArn || "-"}
        />
      </div>
      <div
        className="d-flex justify-content-center mt-4 mb-6 MuiTableCell-root table-cell"
        style={{ border: "none", padding: "4px" }}
        onClick={onConfirm}
      >
        <div className="transaction-button mouse-pointer text-uppercase d-flex align-items-center">
          Confirm
        </div>
      </div>
      <CustomizedDialogsforReintitate
        open={isOpen}
        closeModal={goToDashboard}
        componentName={"STP"}
        refNo={referenceNumber}
        confirmation={goToDashboard}
      />
    </div>
  );
}
